export const isBoolean = (val) => typeof val === 'boolean';

export const isArray = (val) => Array.isArray(val);

export const isNumber = (val) => typeof val === 'number' && !isNaN(val);

export const isString = (val) => typeof val === 'string';